import React, { useState, useEffect } from 'react';
import Box from '../../Box';
import Toast from '../../Toast';
import Tools from '../../Tools';
import ModalWindow from '../../ModalWindow';
import { ReactComponent as CloseIcon } from '../../icons/close.svg';
import MoreMenu from '../../ui/moreMenu/MoreMenu';
import { useSoftphone } from '../../SoftphoneContext.jsx';

const TaskTreeForum = (props) => {

    const [contactTypes, setContactTypes] = useState([]);
    const [responses, setResponses] = useState([]);
    const [taskTypes, setTaskTypes] = useState([]); 
    const [debtReasons, setDebtReasons] = useState([]); 
    const [authTypes, setAuthTypes] = useState([]); 
    const [channels, setChannels] = useState([]); 
    const [actionCodes, setActionCodes] = useState([]); 
    const [showCollectStatus, setShowCollectStatus] = useState(false); 
    const [collectStatus, setCollectStatus] = useState([]); 
    const [error, setError] = useState(false);
    const [toastRef, setToastRef] = useState(React.createRef()); 
    const [client, setClient] = useState(null); 
    const [taskFields, setTaskFields] = useState([]); 
    const [currentCompanyId, setCurrentCompanyId] = useState(null);
    // const [showListofTaskTypes, setShowListofTaskTypes] = useState(false);
    const [allFieldsFilled, setAllFieldsFilled] = useState(false);
    const [loadingTaskTypes, setLoadingTaskTypes] = useState(false);
    const [loadingTaskFields, setLoadingTaskFields] = useState(false);
    const [lockAfterSave, setLockAfterSave] = useState(false);
    const [showTipTerminateCall, setShowTipTerminateCall] = useState(false);
    const [blockedByCurrentCall, setBlockedByCurrentCall] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null); 
    const [showPreviewImage, setShowPreviewImage] = useState(false); 
    const [imageKey, setImageKey] = useState(new Date().valueOf()); 
    //const [data, setData] = useState({ contactType: 0, taskType: 0, actionCode:''}); 
    const [data, setData] = useState({ contactType: 0, taskType: 0, response: 0, authType:null, channel:null}); 

    const [selectedChannel, setSelectedChannel] = useState(null);
    const [selectedContactType, setSelectedContactType] = useState(null);
    const [selectedResponse, setSelectedResponse] = useState(null);
    const [selectedTaskType, setSelectedTaskType] = useState(null);
    const [selectedDebtReason, setSelectedDebtReason] = useState(null);
    const [selectedAuthType, setSelectedAuthType] = useState(null);

    const { incomingCallStatus } = useSoftphone();


    useEffect(() => {
        setClient(props.client);
        

    }, [props.client]);


    useEffect(() => {
        setCurrentCompanyId(props.campaign.companyId);

        //contactTypes
        //fetch(`${process.env.REACT_APP_URI_API_CRM}/contactTypes?idCompany=120`)
        fetch(`${process.env.REACT_APP_URI_API_CRM}/contactTypes?idCompany=${props.campaign.companyId}`)
            .then(res => res.json())
            .then(
                (result) => {
                    setContactTypes(result);
                },
                (error) => {
                    setError(error);
                }
            )


        //responses
        //fetch(`${process.env.REACT_APP_URI_API_CRM}/responses?companyId=120`)
        fetch(`${process.env.REACT_APP_URI_API_CRM}/responses?companyId=${props.campaign.companyId}`)
            .then(res => res.json())
            .then(
                (result) => {
                    setResponses(result);
                },
                (error) => {
                    setError(error);
                }
            )

            

        //taskTypes BY COMPANY
        //contactTypes
        //fetch(`${process.env.REACT_APP_URI_API_CRM}/taskTypes?companyId=120`)
        fetch(`${process.env.REACT_APP_URI_API_CRM}/taskTypes?companyId=${props.campaign.companyId}`)
            .then(res => res.json())
            .then(
                (result) => {
                    setTaskTypes(result);
                },
                (error) => {
                    setError(error);
                }
            )

        // //setCollectStatuses
        // fetch(`${process.env.REACT_APP_URI_API_CRM}/collectStatus?companyId=${props.campaign.companyId}`)
        //     .then(res => res.json())
        //     .then(
        //         (result) => {
        //             setCollectStatus(result);
        //         },
        //         (error) => {
        //             setError(error);
        //         }
        //     )


        //debtReasons
        //fetch(`${process.env.REACT_APP_URI_API_CRM}/debtReasons?companyId=120`)
        fetch(`${process.env.REACT_APP_URI_API_CRM}/debtReasons?companyId=${props.campaign.companyId}`)
            .then(res => res.json())
            .then(
                (result) => {
                    setDebtReasons(result);
                },
                (error) => {
                    setError(error);
                }
            )

        //fetch(`${process.env.REACT_APP_URI_API_CRM}/authTypes?companyId=120`)
        fetch(`${process.env.REACT_APP_URI_API_CRM}/authTypes?companyId=${props.campaign.companyId}`)
            .then(res => res.json())
            .then(
                (result) => {
                    setAuthTypes(result);
                },
                (error) => {
                    setError(error);
                }
            )

        //fetch(`${process.env.REACT_APP_URI_API_CRM}/channels?companyId=120`)
        fetch(`${process.env.REACT_APP_URI_API_CRM}/channels?companyId=${props.campaign.companyId}`)
            .then(res => res.json())
            .then(
                (result) => {
                    setChannels(result);
                },
                (error) => {
                    setError(error);
                }
            )


    }, []);




    useEffect(() => { //VALIDATE TASKTREE
        let allFieldsFilled=true;
        taskFields.forEach(field => {
            if (field.required && (data[field.name] === undefined || data[field.name]==='')){
                allFieldsFilled = false;
            }

            //validacion especifica campos
            let refField = document.getElementsByName(field.name);
            if (refField[0]) {
                if(!refField[0].validity.valueMissing && !refField[0].validity.valid){
                    refField[0].classList.add('invalid');
                    allFieldsFilled = false;
                } else {
                    refField[0].classList.remove('invalid');
                }
            } 
        });
        
        setAllFieldsFilled(allFieldsFilled);
    }, [data, taskFields]);

    // useEffect(() => { //HACK TO CLEAN TASKTYPE AND VALIDATE TASKTREE
    //     setDatos({ ...datos, ['taskType']: 0 });
    // }, [datos.contactType]);


    useEffect(() => {
        if (incomingCallStatus === 'ended' || incomingCallStatus === 'none' || incomingCallStatus === 'failed'){
            setShowTipTerminateCall(false);
        }

        //bloqueo boton guardar gestion si llamada aun no se contesta
        //if(props.campaign.type === "PROGRESSIVE" && (incomingCallStatus !== 'confirmed' && incomingCallStatus !== 'ended' && incomingCallStatus !== 'none' && incomingCallStatus !== 'failed')){
        if((props.campaign.type === "PROGRESSIVE" && (incomingCallStatus !== 'confirmed' && incomingCallStatus !== 'ended' && incomingCallStatus !== 'failed')) ||
            props.campaign.type === "PROGRESSIVE" && incomingCallStatus === 'none'){
           setBlockedByCurrentCall(true); 
        } else{
           setBlockedByCurrentCall(false);
        }
       

    }, [incomingCallStatus]);


    const setFullObject=(id, array, setterFn)=>{
        let object = array.find((t) => t._id === id);
        if (object){
            setterFn(object);
        } 
    }

    const handleInputChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const handleCalendar = (dateValue, fieldName) => {
        setData({ ...data, [fieldName]: dateValue.toISOString() })
    }

    const getTaskFieldsForTaskTypes = (event) => {
        handleInputChange(event);
        getTaskFields(event.target.value);
    }

    // const getTaskFieldsCollectCode = async (event) => {
    //     handleInputChange(event);

    //     const newDatos = { ...data };

    //     const selectedCollectStatus = collectStatus.find((t) => t.code === event.target.value);
    //     if (selectedCollectStatus) {
    //         newDatos.collectStatus = event.target.value;
    //         newDatos.collectStatusDesc = selectedCollectStatus.desc;
    //     } 

    //     const taskFieldsList=await getTaskFields(event.target.value);

    //     //si arreglo es vacio, solo dejar los campos que corresponden a la gestión
    //     //reset fields
    //     if (taskFieldsList.length === 0) {
    //         Object.keys(newDatos).forEach(function (key) {
    //             if (key !== 'contactType' &&
    //                 key !== 'taskType' &&
    //                 key !== 'actionCode' &&
    //                 key !== 'collectStatus' &&
    //                 key !== 'collectStatusDesc' &&
    //                 key !== 'observation' && newDatos[key] !== undefined) {
    //                 console.log('Key eliminar: ' + key + ', Value : ' + newDatos[key]);
    //                 newDatos[key] = undefined;
    //                 //swRefresh = true;
    //             }
    //         });
    //     }

    //     setData(newDatos);

    //     setTaskFields(taskFieldsList);
    //     setLoadingTaskFields(false);
    // }

    const getCollectStatus = (event) => {
        handleInputChange(event);
        

        const selectedTaskType = taskTypes.find((t) => t._id === event.target.value);
        if (selectedTaskType?.collectStatus){
           setShowCollectStatus(true);
        } else {
           setShowCollectStatus(false);
           resetFields();
        }
        
    }

    const resetFields = () => {
        let swRefresh=false;
        const newDatos = { ...data };
        Object.keys(newDatos).forEach(function (key) {
            if (key !== 'contactType' && 
                key !== 'taskType' && 
                key !== 'actionCode' && 
                key !== 'observation' && newDatos[key] !== undefined){ 
                console.log('Key eliminar: ' + key + ', Value : ' + newDatos[key]);
                newDatos[key] = undefined;
                swRefresh=true;
            }
        });

        if(swRefresh){
            setData(newDatos);
        }
        
    }


    const getTaskFields = (taskTypeId) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        setLoadingTaskFields(true);
        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/taskFields`);
        url.search = new URLSearchParams({
            taskTypeId: taskTypeId,
        });

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
            headers: { 'Authorization': currentSessionData.token }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setTaskFields(result);
                    setLoadingTaskFields(false);
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                    setLoadingTaskFields(false);
                }
            )
    }

    const saveTask = (nextUserStatus=null) => {
        //event.preventDefault();

        console.log('🐞DEBUG nextUserStatus1:', nextUserStatus);

        if (incomingCallStatus !== 'ended' && incomingCallStatus !== 'none' && incomingCallStatus !== 'failed'){
            setShowTipTerminateCall(true);
        } else {
            setShowTipTerminateCall(false);
            setLockAfterSave(true); //bloquea botón

            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

            let serviceParams = {
                clientObjectId: props.client._id,
                companyId: props.campaign.companyId,
                companyCode: props.campaign.company_info.code,
                campaignId: props.campaign._id,
                clientId: client.clientId,
                phone: props.client.currentPhone,
                contactType: data.contactType,
                taskType: data.taskType,
                observation: data.observation,

                // collectStatus: data.collectStatus??undefined,
                // collectStatusDesc: data.collectStatusDesc??undefined,
                // actionCode: '9431437',
                // actionDesc: 'LL.Efect.'

                channel: data.channel,
                response: data.response,
                debtReason: data.debtReason,
                authType: selectedAuthType?.code?data.authType:undefined,
                additionalData:{
                    channel:selectedChannel?.code,
                    contactType:selectedContactType?.code,
                    response:selectedResponse?.code,
                    taskType:selectedTaskType?.code,
                    channelIC:selectedChannel?.internalCode,
                    contactTypeIC:selectedContactType?.internalCode,
                    authType:selectedAuthType?.code,
                    debtReason:selectedDebtReason?.code
                }
            };

            let jsonTaskFields = [];
            taskFields.forEach(field => {
                let jsonField={};
                jsonField.name=field.name;
                jsonField.value = data[field.name];
                jsonField.type = field.type;
                jsonTaskFields.push(jsonField);
            });

            serviceParams.taskFields = JSON.stringify(jsonTaskFields);


            //★★★★IMPORTANTE★★★
            //si hay grabacion de audio recupera los datos de la ultima grabacion
            //para verificar si corresponde a esta misma gestion
            //si es asi, entonces incluye un parámetro en los datos de la gestión
            //para que incorpore el dato de la URL

            if(props.lastRecordingData){
                if (props.lastRecordingData.campaignId === props.campaign._id && props.lastRecordingData.clientId === client.clientId){
                    serviceParams.hasAudioRecord=true;
                }
            }


            //console.log('🐞DEBUG JSON.stringify(data):',data);

            let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/tasks`);
            fetch(url, {
                method: 'POST',
                contentType: 'application/json',
                headers: { 'Authorization': currentSessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(serviceParams)
            })
            .then(res => res.json())
            .then(
                (result) => {
                    setData({ contactType: 0, taskType: 0 });
                    document.getElementById('formTask').reset();

                    //refresh taskList
                    //props.callbackAfterSaveTask();

                    toastRef.current.addToast('Una nueva gestión ha sido registrada', 5000);

                    //notify change user status to parent

                    console.log('🐞DEBUG nextUserStatus 2:', nextUserStatus);

                    if (nextUserStatus){
                        props.setUserStatus(nextUserStatus);

                        
                        //NO VA ESTO SI NO LO siguiente:
                        // si está ingresando gestion no debe poder entrar en pausa 



                    } else {
                        props.setUserStatus({ paused: false, code: 'ACTIVE', desc: 'Disponible' });
                    }
                    props.callbackAfterSaveTask();

                    setTaskFields([]);

                    setLockAfterSave(false); //DESBLOQUEA botón


                    if (props.lastRecordingData) {
                        if (props.lastRecordingData.campaignId === props.campaign._id && props.lastRecordingData.clientId === client.clientId) {
                            props.setLastRecordingData(null); 
                        }
                    }
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                }
            )
        }
    }

    const getFileImage=(event)=>{
        const objectUrl = URL.createObjectURL(event.target.files[0])
        setSelectedImage(objectUrl)

        let targetName = event.target.name;
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
            setData({ ...data, [targetName]: reader.result });
        }
    }

    const resetImage=(event, fieldName)=>{
       setSelectedImage(null);
       setImageKey(new Date().valueOf()); 
       setData({ ...data, [fieldName]: undefined });
    }




    return (
        <form id="formTask" noValidate>
            <Toast ref={toastRef}></Toast>

            {showTipTerminateCall?(
                <div className="mustTerminateCallIndicator">Debe finalizar la llamada para poder ingresar la gestión</div>
            ):null}

            
            {showPreviewImage?(
                <ModalWindow closeMethod={() => setShowPreviewImage(!showPreviewImage)}>
                    <img className='bigPreview' src={selectedImage}/>
                </ModalWindow>
            ) : null}


            <h4 className="sectionTitle">ARBOL DE GESTIÓN</h4>
            <div className="flexRow">
                <div className="flexCol">

                    <Box type="select" name="channel" label="Canal" className="x2" placeholder="Seleccione ..." options={channels} onChange={(e) => { handleInputChange(e); setFullObject(e.target.value, channels, setSelectedChannel)}} required></Box>

                    <Box type="select" name="contactType" label="Tipo contacto" className="x2" placeholder="Seleccione ..." options={contactTypes} onChange={(e) => {handleInputChange(e); setFullObject(e.target.value, contactTypes, setSelectedContactType)}} required></Box>
                    
                    <Box type="select" name="response" label="Respuesta" className="x4" placeholder="Seleccione ..." options={responses} onChange={(e) => { { let datatmp = { ...data }; data.debtReason=undefined; setData(datatmp); setSelectedDebtReason(null)};handleInputChange(e); setFullObject(e.target.value, responses, setSelectedResponse)}} required></Box>
                    
                    <Box type="select" name="taskType" label="Tipo de gestión" className="x3" placeholder="Seleccione ..." options={taskTypes} onChange={(e) => { handleInputChange(e); setFullObject(e.target.value, taskTypes, setSelectedTaskType); getTaskFieldsForTaskTypes(e) }} required></Box>
                   
                    {selectedResponse?.debtReason?(
                        <Box type="select" name="debtReason" label="Motivo de no pago" className="x3" placeholder="Seleccione ..." options={debtReasons} onChange={(e) => { handleInputChange(e); setFullObject(e.target.value, debtReasons, setSelectedDebtReason) }} required></Box>
                    ):null}

                    {selectedContactType?.authNewContact ?(
                        <Box type="select" name="authType" label="Autorización" className="x4" placeholder="Seleccione ..." options={authTypes} onChange={(e) => { handleInputChange(e); setFullObject(e.target.value, authTypes, setSelectedAuthType) }} required></Box>
                    ):null}
                   
                    {/* {showCollectStatus ?(
                        <Box type="select" name="collectStatus" label="Estado cobranza" className="x2" placeholder="Seleccione ..." options={collectStatus} onChange={getTaskFieldsCollectCode} required></Box>
                    ) : null} */}

                    {taskFields.map((field, index) => {
                        switch (field.type) {
                            case 'TXT':
                                return (<Box key={index} type="text" name={field.name} label={field.desc} className="x5" placeholder="Ingrese ..." onChange={handleInputChange} required={field.required}></Box>)
                                break;
                            case 'AMM':
                                return (<Box key={index} type="number" name={field.name} className="x2" label={'$ ' + field.desc} placeholder="Ingrese monto" onChange={handleInputChange} required={field.required} max={field.max?props.max:(Number(props.debt)+1)}></Box>) //regla para monto maximo deuda
                                break;
                            case 'NUM':
                                return (<Box key={index} type="number" name={field.name} className="x2" label={field.desc} placeholder="Ingrese" onChange={handleInputChange} required={field.required}></Box>)
                                break;
                            case 'DATE':
                                //return (<Box key={index} type="calendar" name={field.name} className="x2" label={field.desc} selectedDate={datos.commitmentDate} onChange={handleCalendar} required></Box>)
                                return (<Box key={index} type="calendar" name={field.name} className="x2" label={field.desc} selectedDate={data.commitmentDate} onChange={(e) => handleCalendar(e, field.name)} limitDaysAfter={field.limitDaysAfter} required={field.required}></Box>)
                                break;
                            case 'LIST':
                                return (<Box key={index} type="select" name={field.name} className="x2" label={field.desc} placeholder="Seleccione ..." genericListCode={field.list_code} companyId={currentCompanyId} onChange={handleInputChange} required={field.required}></Box>)
                                break;
                            case 'IMG':
                                return (
                                    <Box type="content" label="Imagen respaldo" className="x4 fileInput img" required={field.required}>
                                        <div>
                                            <input key={imageKey} name={field.name} type="file" onChange={getFileImage} accept="image/*" />
                                            {selectedImage ? (
                                                <div className="deleteImage">
                                                    <a className='close' onClick={(e) => resetImage(e, field.name)}><CloseIcon/></a>
                                                    <img className='preview' src={selectedImage} onClick={() => setShowPreviewImage(!showPreviewImage)}/>
                                                </div>
                                            ) : null}
                                        </div>
                                    </Box>
                                )
                                break;
                        }
                    })
                    }  

                    <Box type="text" name="observation" label="Observación" className="x5" placeholder="Ingrese observación..." onChange={handleInputChange}></Box>           

                </div>
            </div>

            {Tools.clientIsBlocked(client)? (
                <p className='clientDisclaimer'>*Usuario bloqueado, no se permite registrar gestión de ejecutivos.</p>
            ) : null}

            {props.campaign.type === "PROGRESSIVE" && incomingCallStatus === 'none' ?(
                <p className='clientDisclaimer'>*Bloqueo por llamada no disponible.</p>
            ):null}

            <div className="flexRow">
                <div className="flexCol">

                    {/* <p className='debug'>data:{JSON.stringify(data)}</p><br/> */}
                    {/* <p className='debug'>selectedChannel:{JSON.stringify(selectedChannel)}</p><br />
                    <p className='debug'>selectedContactType:{JSON.stringify(selectedContactType)}</p><br /> */}
                    {/* <p className='debug'>selectedResponse:{JSON.stringify(selectedResponse)}</p><br /> */}
                    {/* <p className='debug'>selectedTaskType:{JSON.stringify(selectedTaskType)}</p><br /> */}
                    {/* <p className='debug'>selectedDebtReason:{JSON.stringify(selectedDebtReason)}</p><br /> */}
                    {/* <p className='debug'>selectedAuthType:{JSON.stringify(selectedAuthType)}</p><br /> */}
                    {/* <hr/>
                    <p className='debug'>GESTION FORUM:
                        <span>
                            CHANN:{selectedChannel?.code} | 
                            CONT:{selectedContactType?.code} | 
                            RESP:{selectedResponse?.code} | 
                            TASK:{selectedTaskType?.code} | 
                            CHANN.IC:{selectedChannel?.internalCode} | 
                            CONT.IC:{selectedContactType?.internalCode} |  
                            AUT:{selectedAuthType?.code} | 
                            DEBTR:{selectedDebtReason?.code} 
                        </span>
                    </p> */}

                    {/* <br /><br /><br /><p>taskTypes:{JSON.stringify(taskTypes)}</p> */}
                    {/* <p>taskFields:{JSON.stringify(taskFields)}</p>
                    <p>allFielsFilled: {allFieldsFilled.toString()}</p> */}
                    {/* <button className={(datos.contactType === 0 || datos.taskType === 0 || datos.actionCode === '' || !allFieldsFilled || lockAfterSave || Tools.clientIsBlocked(client) || blockedByCurrentCall) ? 'default disabled' : 'default'} type="button" onClick={() => saveTask()}>Guardar gestión</button> */}
                    {/* <button  type="button" onClick={() => saveTask()}>XxXXXXX</button>  */}
                
                    
                        <div className="bottonDropdown">
                        <button className={(data.contactType === 0 || data.taskType === 0 || data.response === 0 || (selectedContactType.authNewContact && data.authType === null) || selectedChannel === null || (selectedResponse?.debtReason && data.debtReason===undefined) || !allFieldsFilled || lockAfterSave || Tools.clientIsBlocked(client) || blockedByCurrentCall) ? 'default dropdown left disabled' : 'default dropdown left'} type="button" onClick={() => saveTask()}>Guardar gestión</button>
                        <button className={(data.contactType === 0 || data.taskType === 0 || data.response === 0 || (selectedContactType.authNewContact && data.authType === null) || selectedChannel === null || (selectedResponse?.debtReason && data.debtReason === undefined) || !allFieldsFilled || lockAfterSave || Tools.clientIsBlocked(client) || blockedByCurrentCall) ? 'default dropdown end disabled' : 'default dropdown end'} type="button">
                                <MoreMenu title="GUARDAR GESTIÓN y entrar en pausa" menuList={
                                    [
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon ADM' />ADMINISTRATIVO</span>,
                                            action: () => { saveTask({ paused: true, code: 'ADM', desc: 'Administrativo' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon ALM' />ALMUERZO</span>,
                                            action: () => { saveTask({ paused: true, code: 'ALM', desc: 'Almuerzo' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon BK' />BREAK</span>,
                                            action: () => { saveTask({ paused: true, code: 'BK', desc: 'Break' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon BN' />BAÑO</span>,
                                            action: () => { saveTask({ paused: true, code: 'BN', desc: 'Baño' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon CP' />CAPACITACIÓN</span>,
                                            action: () => { saveTask({ paused: true, code: 'CP', desc: 'Capacitación' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon REU' />REUNIÓN</span>,
                                            action: () => { saveTask({ paused: true, code: 'REU', desc: 'Reunión' }); },
                                            visible: true
                                        },

                                    ]
                                } />
                            </button>
                        </div>
                    




                
                </div>
            </div>

        </form>
        
    );

}

export default TaskTreeForum;





